import { Component, OnInit, NgZone } from '@angular/core';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Toast } from '../globals'
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ToastController } from '@ionic/angular';
import Swal from 'sweetalert2';
import { LoadingController } from '@ionic/angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  model: any = {};
  url: any = '';

  ChRememberme: any;

  constructor(private login_serv: LoginService, private router: Router, private alertController: AlertController, public zone: NgZone, private toastController: ToastController, private loadingCtrl: LoadingController) {
    this.model.username = "";
    this.model.pass = "";
  }

  ngOnInit() {
  }

  async presentToast(color, msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 1500,
      color: color,
      position: 'top'
    });

    await toast.present();
  }

  async showLoading() {
    const loading = await this.loadingCtrl.create({
      message: 'Loading...',
      duration: 5000,
      spinner: 'crescent',

    });

    loading.present();
  }


  Login() {
    console.log("this.model", this.model)
    if (this.model.username == "" || this.model.pass == "") {
      console.log("hi")
      this.presentToast('danger', 'Please enter the information');

      // Swal.fire({
      //   title: 'Good job!',
      //   text: 'You clicked the button!',
      //   heightAuto: false,
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   // confirmButtonText: 'بله',
      //   // cancelButtonText: 'خیر'

      //   // }).then((result) => {
      //   //   if (result.isConfirmed) {

      //   //   }
      // });

      return;
    }
    this.showLoading();
    // Save Username and Password :
    if (this.ChRememberme === true) {
      Cookie.set('Username', this.model.username);
      Cookie.set('Password', this.model.pass);
    }

    this.login_serv.Login(this.model).subscribe(
      res => {
        console.log("res", res)

        this.zone.run(() => {
          if (res != 0) {

            localStorage.setItem("Session_AppUserID", res['appUserID'].toString());
            localStorage.setItem("Session_Name", res['firstName']);
            localStorage.setItem("Session_LastName", res['lastName']);

            localStorage.setItem("Session_EmailAddress", res['emailAddress']);
            localStorage.setItem("Session_Password", res['password']);
            localStorage.setItem("Session_Phone", res['phone']);
            localStorage.setItem("Session_BrithDate", res['brithDate']);
            localStorage.setItem("Session_Sex", res['sex']);
            localStorage.setItem("Session_FK_CityID", res['fK_CityID']);

            this.url = "/home";
            this.router.navigate([this.url]);
          } else {
            this.presentToast('danger', 'Invalid username ot password');
            this.model = {};
          }

        });


      }, err => {
        console.log(err);
      });

  }

  Register() {
    this.router.navigate(["/register"]);
  }


}
